module.exports = __webpack_public_path__ + "static/img/kw.c244f6de.svg";